import {DqElement} from 'module/Dq/searchDq'

export function filterOption(option: DqElement, searchTerm: string) {
	if (option._specialFirstEntry) {
		return true
	} else {
		searchTerm = searchTerm.trim()
		if (!searchTerm) return true;
		searchTerm = searchTerm.replace(/[.+^${}()|[\]\\*?]/g, '\\$&')
		searchTerm = searchTerm.replace(/\\\*/g, '.*').replace(/\\\?/g, '.')
		return [option.value, option.label].some(x => {
			const str = x ? x + '' : null
			if (!str?.trim().length) return false
			const re = new RegExp(searchTerm, 'i')
			return re.test(str + '')
		})
	}
}

export function filterOptionReactSelect<T extends {
	value: string | number | null | undefined,
	label: string | number | null | undefined,
	data: DqElement
}>(option: T, searchTerm: string) {
	return filterOption(option.data, searchTerm)
}